import {ConnectBasicEntity} from '../../framework/message/ConnectBasicEntity';

export class AuthConfigParameter extends ConnectBasicEntity {
authCode: string;
kind: string;
parameterCode: string;
parameterValue: string;
}

